import { Divider, Radio, Table } from 'antd';
// import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

interface Props {
  //   productsData: any;
  getProductList: Function;
  rowDataProducts: any;
  totalProduct: number;
  loading: boolean;
  selectedProduct: React.Key[];
  setSelectedProduct: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageProduct: Function;
}

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: '상품명',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: '수량',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: '물류센터명',
    dataIndex: 'logisticCenter',
    key: 'logisticCenter'
  },
  {
    title: '적재 위치',
    dataIndex: 'loadingPlace',
    key: 'loadingPlace'
  }
];

const ProductTable = ({
  rowDataProducts,
  totalProduct,
  loading,
  selectedProduct,
  setSelectedProduct,
  handleChangePageProduct
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedProduct(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedProduct,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        pagination={{
          pageSize: 10,
          total: totalProduct,
          onChange: (newPage) => {
            handleChangePageProduct(newPage);
          }
        }}
        loading={loading}
        columns={columns}
        dataSource={rowDataProducts}
      />
    </div>
  );
};

export default ProductTable;
